import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProductCategories from './components/ProductCategories';
import CustomCase from './components/CustomCase';
import SocialMedia from './components/SocialMedia';
import WhyUs from './components/WhyUs';
import StoreInfo from './components/StoreInfo';
import WhatsAppCTA from './components/WhatsAppCTA';
import Footer from './components/Footer';
import StickyWhatsApp from '../../components/feature/StickyWhatsApp';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Navbar />
      <Hero />
      <ProductCategories />
      <CustomCase />
      <SocialMedia />
      <WhyUs />
      <StoreInfo />
      <WhatsAppCTA />
      <Footer />
      <StickyWhatsApp />
    </div>
  );
}
